// src/config/app-route.jsx
import React, { useEffect, useState } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
// import jwtDecode from 'jwt-decode';
import { jwtDecode } from 'jwt-decode';

import App from './../app.jsx';
import Login from '../pages/user/login.jsx';
import Otp from '../pages/user/otp.jsx';
import Loan001 from '../pages/loan/loan_001.jsx';
import Loan002 from '../pages/loan/loan_002.jsx';
import Loan002_standalone from '../pages/loan/loan_002_standalone.jsx';
import Loan003 from '../pages/loan/loan_003.jsx';
import Loan002_06 from '../pages/loan/loan_002_06.jsx';
import Bond001 from '../pages/bond/bond_001.jsx';
import Bond002 from '../pages/bond/bond_002.jsx';
import Bond002_01 from '../pages/bond/bond_002_01.jsx';
import Acct001 from '../pages/acct/acct_001.jsx';
import Acct002 from '../pages/acct/acct_002.jsx';
import Sanc001 from '../pages/sanc/sanc_001.jsx';
import Sanc002 from '../pages/sanc/sanc_002.jsx';
import Sanc003 from '../pages/sanc/sanc_003.jsx';
import Base003 from '../pages/base/base_003.jsx';
import Prop001 from '../pages/prop/prop_001.jsx';
import Prop002 from '../pages/prop/prop_002.jsx';
import Report001 from '../pages/report/report_001.jsx';
import Report002 from '../pages/report/report_002.jsx';
import Report003 from '../pages/report/report_003.jsx';
import Settings001 from '../pages/settings/settings_001.jsx';
import Settings002 from '../pages/settings/settings_002.jsx';
import Detail from '../pages/detail/detail.jsx';

import { getUserInfo } from "../reducers/selectors/selectors.jsx";
import { clearUserState } from '../reducers/userReducers.jsx';
import { clearMenuState } from '../reducers/menuReducers.jsx';
import { clearLangCodeState } from '../reducers/langCodeReducers.jsx';
import { store } from "../store.jsx";
import { useDispatch, useSelector } from 'react-redux';

const AppRoute = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [userInfoChecked, setUserInfoChecked] = useState(false);
    const accessToken = useSelector(state => state.login.userInfo?.access_token);
    const persistInfo = sessionStorage.getItem('persist:login');

    useEffect(() => {
        const checkUserInfo = async () => {
            const userInfo = await getUserInfo(store.getState());
            if (!userInfo) {
                navigate('/login', { replace: true });
            }
            setUserInfoChecked(true);
        };
        if (!userInfoChecked) checkUserInfo();

        const isUrlEmpty = window.location.pathname === '/' || window.location.pathname === '';
        if (isUrlEmpty) navigate('/loan/loan_001', { replace: true });
    }, [navigate, userInfoChecked]);

    useEffect(() => {
        const checkTokenExpiration = () => {
            if (accessToken) {
                const decodedToken = jwtDecode(accessToken);
                const expirationTimeInSeconds = decodedToken.exp;
                const currentTimeInSeconds = Math.floor(Date.now() / 1000);

                if (expirationTimeInSeconds < currentTimeInSeconds) {
                    dispatch(clearUserState());
                    dispatch(clearMenuState());
                    dispatch(clearLangCodeState());
                    localStorage.removeItem('langCodeInfo');
                    navigate('/login', { replace: true });
                }
            }
        };
        checkTokenExpiration();
    }, [accessToken, navigate, dispatch]);

    useEffect(() => {
        if (!persistInfo) {
            navigate('/login', { replace: true });
        };
    }, [persistInfo, navigate]);

    if (!userInfoChecked) return null;

    return (
        <Routes>
            {/* standalone 페이지: App 레이아웃 없이 렌더링 */}
            <Route path="/bond/bond_002_01" element={<Bond002_01 />} />
            <Route path="/:page/detail/:loanReceivableId" element={<Detail />} />
            <Route path="/loan/loan_002_06" element={<Loan002_06 />} />
            <Route path="/loan/loan_002_standalone" element={<Loan002_standalone />} />

            {/* App 레이아웃 안에서 렌더링되는 페이지 */}
            <Route path="" element={<App />}>
                <Route path="/login" element={<Login />} />
                <Route path="/login/otp" element={<Otp />} />
                <Route path="/loan/loan_001" element={<Loan001 />} />
                <Route path="/loan/loan_002" element={<Loan002 />} />
                <Route path="/loan/loan_003" element={<Loan003 />} />
                <Route path="/bond/bond_001" element={<Bond001 />} />
                <Route path="/bond/bond_002" element={<Bond002 />} />
                <Route path="/acct/acct_001" element={<Acct001 />} />
                <Route path="/acct/acct_002" element={<Acct002 />} />
                <Route path="/sanc/sanc_001" element={<Sanc001 />} />
                <Route path="/sanc/sanc_002" element={<Sanc002 />} />
                <Route path="/sanc/sanc_003" element={<Sanc003 />} />
                <Route path="/base/base_003" element={<Base003 />} />
                <Route path="/prop/prop_001" element={<Prop001 />} />
                <Route path="/prop/prop_002" element={<Prop002 />} />
                <Route path="/report/report_001" element={<Report001 />} />
                <Route path="/report/report_002" element={<Report002 />} />
                <Route path="/report/report_003" element={<Report003 />} />
                <Route path="/settings/settings_001" element={<Settings001 />} />
                <Route path="/settings/settings_002" element={<Settings002 />} />
            </Route>
        </Routes>
    );
};

export default AppRoute;
